import { lazy, type ComponentType } from 'react'

// Wraps a resource's list/edit/create/show in React.lazy so Vite gives each app its own
// chunk, fetched only when that route is visited. Layout already wraps routes in Suspense.
export function lazyResourceComponent<T>(
  loader: () => Promise<T>,
  select: (module: T) => ComponentType | undefined,
): ComponentType {
  return lazy(async () => ({ default: select(await loader()) as ComponentType }))
}
